<!-- 配件销售统计 -->
<template>
    <div class="searchAp-ctn" id="apSaleStat">
        <div class="search-ctn" style="margin-top: 10px;">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name" v-if="showCusData">客户</div>
                    <div>
                        <el-input
                            class="search-item"
                            size="small"
                            v-model.trim="searchData.Keyword"
                            v-filter-special-char="searchData.Keyword"
                            placeholder="客户名称"
                            v-if="showCusData"
                        ></el-input>
                    </div>
                    <div class="search-name">业务员</div>
                    <div>
                        <el-select
                            v-model="searchData.SId"
                            filterable
                            clearable
                            remote
                            size="small"
                            placeholder="选择业务员"
                            @visible-change="siVisibleChange($event)"
                            style="width: 100%"
                        >
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">提交时间</div>
                    <el-date-picker
                        v-model="datetime"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        style="width: 280px;"
                        size="small"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                style="width: 100%; margin-bottom: 0"
                :default-sort="{ prop: 'AllAmount', order: 'descending' }"
                @sort-change="sortChange"
            >
                <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="180px" prop="EntpCusName" label="客户" v-if="showCusData"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="110px" sortable="custom" prop="AllAmount" label="购买总额"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="110px" sortable="custom" prop="AllCount" label="购买总数"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="110px" sortable="custom" prop="SingleTopPrice" label="最高单价"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="130px" sortable="custom" prop="SingleTopCount" label="单次最高总量"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" sortable="custom" prop="AllCost" label="总成本"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" sortable="custom" prop="AllProfit" label="总利润"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="140px" sortable="custom" prop="LastDate" label="最后购买时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="LastSName" label="业务员"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        ShowCus: {
            type: Boolean,
            default: false
        },
        ShowSales: {
            type: Boolean,
            default: true
        },
        APId: String
    },
    data() {
        return {
            timeVisible: false,
            loading: false,
            searchData: {
                APId: '',
                Keyword: '',
                SortProp: '',
                SortType: '',
                SId: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            SIdList: [],
            tableDataLength: 0,
            showCusData: false,
            ShowSalesData: true,
            datetime:[],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.getTableData();
        this.searchData.APId = this.APId;
        if (this.ShowCus) this.showCusData = this.ShowCus;
        this.ShowSalesData = this.ShowSales;
        let dialogbody = document.querySelector('#apSaleStat');
        this.$util.setEventForDialog(this, dialogbody);
    },
    methods: {
        resetSearch() {
            this.searchData = {
                APId: this.APId,
                Keyword: '',
                SortProp: '',
                SortType: '',
                SId: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10
            };
            this.datetime=[];
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/GetEntpSaleOrderListByAPId',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        getSIdList() {
            this.$util.getSalemanList().then(data => {
                this.SIdList = data;
            });
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
    }
};
</script>
<style lang="less">
#apSaleStat {
    overflow-y: auto;

    .el-date-editor {
        width: 240px;
    }
}
</style>
